import "./Client.css";
import client1 from "../Assets/ceo.jpg"; 
import client2 from "../Assets/client2.jpeg";
import client3 from "../Assets/client3.jpeg";

function Client() {
  const reviews = [
    {
      name: "K E Jas",
      title: "Founder, SALISONS.",
      review:
      "Enjoyed the informativeness, transparency and accountability of Amy Floris throughout the process of Certification",
      rating: 5,
      image: client1,
    },
    {
      name: "Pramod Wankhede",
      title: "Quality Head, JM Alluminium",
      review:
        "Amy Floris provided exceptional guidance throughout our BIS certification process. Their expertise saved us significant time and resources.",
      rating: 5,
      image: client2,
    },
    {
      name: "Canon Lee",
      title: "Sales & Marketing Manager,Formosa Shyen Horng Metal, Malaysia",
      review:
        "Amy Floris provided exceptional support in obtaining our BIS license under FMCS. The expertise and proactive guidance made the entire process smooth and successful.",
      rating: 5,
      image: client3,
    },
  ];
  const counts = [
    { number: "20+", label: "Years of Experience", color: "#2E3192" },
    { number: "500+", label: "Licenses Obtained", color: "#92278F" },
    { number: "200+", label: "Clients", color: "#00A651" },
    { number: "60+", label: "Industries Served", color: "#F15A29" },
  ];

  return (
    <>

    <div className="client-background">
      <div className="client-title">What Our Clients Say</div>
      <div className="client-sub-title">
        Hear from our clients about their experience working with Amy Floris.
      </div>

      <div className="client-cards-container">
        {reviews.map((client, index) => (
          <div
            className={`client-card ${index === 0 ? "highlight" : ""}`}
            key={index}
          >
            <div className="stars">{"★".repeat(client.rating)}</div>
            <p className="client-review">"{client.review}"</p>
            <div className="client-info">
              <div className="client-avatar">
                <img src={client.image} alt={client.name} />
              </div>
              <div className="client-details">
                <h4>{client.name}</h4>
                <p>{client.title}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>

    <div className="count-section">
      {counts.map((item, index) => (
        <div className="count-card" key={index}>
          <div className="count-number" style={{ color: item.color }}>
            {item.number}
          </div>
          <div className="count-label">{item.label}</div>
        </div>
      ))}
    </div>
  </>
);
}


export default Client;
